import CustomDatePicker from './CustomDatePickerContainer';

export default CustomDatePicker;
